
import { lazy, Suspense } from "react";

const WasmMemoryTest = lazy(() => import("./views/WasmMemoryTest"));
const WasmBenchmark = lazy(() => import("./views/WasmBenchmark"));

export const RoutesConfig = [
    {
        href: "/wasm-memory",
        Component: WasmMemoryTest,
        title: "Wasm Memory Test",
    },
    {
        href: "/wasm-benchmark",
        Component: WasmBenchmark,
        title: "Wasm Benchmark",
    },
]